import React, { useCallback } from 'react';
import { type Color, type Gradient } from '../types';
import { GradientPicker } from './GradientPicker/GradientPicker';
import { SolidColorPicker } from './SolidColorPicker/SolidPicker';
import { useColorPicker } from './InternalColorPickerContext';

interface Props {
    defaultValue: Color;
    onChange: (newValue: Color) => void;
    isColorTypeChangeAllowed?: boolean;
}

export function InternalColorPicker(props: Props) {
    const { setUserColor } = useColorPicker();

    const onChange = useCallback(
        (color: Color) => {
            setUserColor(color);
            props.onChange(color);
        },
        [props.onChange, setUserColor],
    );

    if (isGradient(props.defaultValue)) {
        return (
            <GradientPicker
                defaultValue={props.defaultValue}
                setValue={onChange}
                isColorTypeChangeAllowed={props.isColorTypeChangeAllowed}
            />
        );
    }

    return (
        <SolidColorPicker
            defaultValue={props.defaultValue}
            onChange={onChange}
            isColorTypeChangeAllowed={props.isColorTypeChangeAllowed}
        />
    );
}

function isGradient(color: Color): color is Gradient {
    return typeof color === 'object' && 'type' in color && ['linear', 'radial'].includes(color.type);
}
